// React
import React from "react";
// Libraries
import { useQuery } from "@apollo/client";
// Utils
import { getBUFromLocalStorage } from "helpers/storage";
// API
import { GetContactList, GetContactList_contacts, GetContactListVariables } from "api/AddressBook/types/GetContactList";
import { GET_ADDRESS_BOOK_LIST } from "api/AddressBook/queries";
// Components
import { FieldSelect } from "components/Common/Field/Select";

type Props = {
  value: string;
  onContactChange: (contact: GetContactList_contacts | undefined) => void;
  label?: string;
  errorMessage?: string;
  disabled?: boolean;
  contactType?: string;
  onCreateNewContact?: () => void;
};

const CREATE_NEW_CONTACT = "createNewContact";

export const AddressBookSelect: React.FC<Props> = ({
  onCreateNewContact,
  onContactChange,
  value,
  label,
  errorMessage,
  disabled,
  contactType,
}) => {
  const businessUnit = getBUFromLocalStorage();

  const { data, loading } = useQuery<GetContactList, GetContactListVariables>(GET_ADDRESS_BOOK_LIST, {
    variables: {
      businessUnit,
      contactType,
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });
  const contacts = (data?.contacts || []) as GetContactList_contacts[];

  const formattedContacts = contacts.map((item) => ({
    key: item.id,
    value: item.id,
    label: item.name,
  }));

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    if (onCreateNewContact && e.target.value === CREATE_NEW_CONTACT) {
      onCreateNewContact();
    }

    const selectedContact = contacts.find((item) => item.id === e.target.value);
    onContactChange(selectedContact);
  };

  return (
    <FieldSelect
      label={label}
      error={errorMessage}
      inputProps={{
        name: "contact",
        placeholder: "Select from Address Book",
        value: value,
        options: onCreateNewContact
          ? [{ key: CREATE_NEW_CONTACT, value: CREATE_NEW_CONTACT, label: "Create New Contact" }, ...formattedContacts]
          : formattedContacts,
        onChange: handleChange,
        isClearable: true,
        disabled: loading || disabled,
      }}
    />
  );
};
